import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-showcase',
  template: `
    <app-navigation-secondary-showcase></app-navigation-secondary-showcase>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryShowcaseComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/compat/compat-navigation-secondary-showcase.component.ts